export const TestId = {
  root: 'ContinueWithWixButton',
}
